import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    storeList: { stores: [], total: 0, pageSize: 0, error: null, loading: false },
    activeStore: { store: null, error: null, loading: false },
    newStore: { store: null, error: null, loading: false },
    updateStore: { store: null, error: null, loading: false },
    deleteStore: { store: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_STORES:
            return {
                ...state,
                storeList: {
                    ...state.storeList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_STORES_SUCCESS:
            return {
                ...state,
                storeList: {
                    stores: action.payload.stores,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_STORES_FAILURE:
            return {
                ...state,
                storeList: {
                    stores: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_STORES:
            return { ...state, storeList: initialState.storeList }



        case actionTypes.FETCH_STORE:
            return { ...state, activeStore: { store: null, error: null, loading: true } }

        case actionTypes.FETCH_STORE_SUCCESS:
            return { ...state, activeStore: { store: action.payload.store, error: null, loading: false } }

        case actionTypes.FETCH_STORE_FAILURE:
            return { ...state, activeStore: { store: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_STORE:
            return { ...state, activeStore: initialState.activeStore }



        case actionTypes.CREATE_STORE:
            return {
                ...state,
                newStore: {
                    store: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_STORE_SUCCESS:
            return {
                ...state,
                newStore: {
                    store: action.payload.store,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_STORE_FAILURE:
            return {
                ...state,
                newStore: {
                    store: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_STORE:
            return { ...state, newStore: initialState.newStore }




        case actionTypes.UPDATE_STORE:
            return { ...state, updateStore: { store: null, error: null, loading: true } }

        case actionTypes.UPDATE_STORE_SUCCESS:
            return { ...state, updateStore: { store: action.payload.store, error: null, loading: false } }

        case actionTypes.UPDATE_STORE_FAILURE:
            return { ...state, updateStore: { store: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_STORE:
            return { ...state, updateStore: initialState.updateStore }



        case actionTypes.DELETE_STORE:
            return { ...state, deleteStore: { store: null, error: null, loading: true } }

        case actionTypes.DELETE_STORE_SUCCESS:
            return { ...state, deleteStore: { store: action.payload.store, error: null, loading: false } }

        case actionTypes.DELETE_STORE_FAILURE:
            return { ...state, deleteStore: { store: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_STORE:
            return { ...state, deleteStore: initialState.deleteStore }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/store/reducer.js